import { render, staticRenderFns } from "./RelatieOverview.vue?vue&type=template&id=78f5b698"
import script from "./RelatieOverview.vue?vue&type=script&lang=js"
export * from "./RelatieOverview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports